module.exports = __webpack_public_path__ + "static/media/image.4836b64d.svg";